import React from 'react'

import { AnchorLink } from 'gatsby-plugin-anchor-links'
import PropTypes from 'prop-types'

import Illustration from '../helpers/Illustration'
import Shape from '../helpers/Shape'
import * as S from './styled'

const ConversionBox = ({
  className,
  headText,
  textColor,
  bdColor,
  bgColor,
  actions
}) => (
  <S.ConversionBoxContainer>
    <S.ConversionBoxWrapper
      className={className}
      textColor={textColor}
      bdColor={bdColor}
      bgColor={bgColor}
      padding="50"
    >
      <S.ConversionBoxContent>
        <S.ConversionTitle
          dangerouslySetInnerHTML={{ __html: headText }}
          color="white"
          semibold
        />
        <S.ConversionButtonGroup>
          {actions.map(({ label, to, color }, i) => (
            <S.ConversionButton
              key={i}
              to={to}
              title={label}
              as="a"
              href="https://superlogica.com/trial"
              target="_blank"
              color={color}
              className="d-block d-xs-inline-block"
            >
              {label}
            </S.ConversionButton>
          ))}
        </S.ConversionButtonGroup>
      </S.ConversionBoxContent>
      <S.ConversionIllustration>
        <Illustration name="circle-waves" color="neutral300" />
      </S.ConversionIllustration>
      <Shape name="line-circle" color="aqua500" size={75} />
      <Shape name="half-circle" color="yellow500" size={75} />
    </S.ConversionBoxWrapper>
  </S.ConversionBoxContainer>
)

ConversionBox.propTypes = {
  className: PropTypes.string,
  headText: PropTypes.string,
  textColor: PropTypes.string,
  bdColor: PropTypes.string,
  bgColor: PropTypes.string,
  actions: PropTypes.array
}

export default ConversionBox
